<template lang="html">
  <v-app>
    <header>
      <v-app-bar color="black" dense flat>
        <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

        <v-tabs>
          <v-tab
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :to="menuItem.url"
          >
            {{ menuItem.name }}
          </v-tab>
          <v-tabs-slider color="transparent"></v-tabs-slider>
          <!-- v-tabs-slider カラーのプロパティでアンダーバーの色設定できた-->
        </v-tabs>
      </v-app-bar>
      <!-- ここから -->
      <v-navigation-drawer v-model="drawer" fixed temporary color="black">
        <v-list nav dense>
          <v-list-item-group>
            <v-list-item
              v-for="(menuItem, index) in menuItems"
              :key="index"
              :to="menuItem.url"
            >
              <v-list-item-title>{{ menuItem.name }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <!-- ここまで -->
    </header>
  </v-app>
</template>

<script>
  import constants from "../common/constants.js"; // 今回追加

  export default {
    data() {
      return {
        drawer: false,
        menuItems: constants.menuItems, // 今回追加
      };
    },
  };
</script>

<style scoped>
  @import "../css/pageprimary.css";
  .v-tab {
    display: flex;
    justify-content: flex-end !important;
    font-family: nitalago-ruika !important;
    font-size: 1.5em;
    color: #fff;
    z-index: 100;
    position: relative;
    border-right: 1px solid #fff;
  }
  @media screen and (max-width: 768px) {
    .v-tab {
      height: auto;
      justify-content: space-between;
      font-size: 1.2em;
    }
  }
  .v-tab:last-child {
    border-right: none;
  }

  .v-toolbar__title {
    overflow: visible !important;
    margin-right: 50px !important;
  }
  .v-tab--active {
    color: var(--v-primary-base);
  }
</style>
